export const colors = {
    primary: '#00CFB2',
    primaryLight: '#00cfb24f',
    dark: '#404040',
    black: '#000000',
    grey: '#707070',
    lightGrey: '#CDD4D8',
    whiteDirty: '#FDFDFD'
};
